import { useQuery } from "@tanstack/react-query";
import { ActivityService } from "$services";
import useAuth from "./useAuth";
import { Activity } from "$types";

export const useActivitiesQuery = () => {
  const { token } = useAuth();

  return useQuery<Activity[]>({
    queryKey: ["getActivities"],

    // Using string key as it might not be in enum yet, or I'll add it
    queryFn: () => ActivityService.getActivities(token),

    enabled: !!token,

    // Activities change rarely
    staleTime: 60 * 60 * 1000,
  });
};
